module.exports = __webpack_public_path__ + "img/jcb.55da5967.svg";